module.exports = __webpack_public_path__ + "img/Menu-13.043fd934.jpg";